// import { IHttpService } from 'repository/IHttpService';
// import { IUserService as IUserRepository } from './IAuthService';

export class UserRepository implements IUserRepository {

    private httpService: IHttpService;

    constructor(instance: IHttpService) {
        this.httpService = instance;
    }

    async createUser(data: UserCreateDTO) {
        const response = await this.httpService.post<UserCreateResponse, UserCreateDTO>('/v1/user', { data });
        return response.data;
    }

    async getUsers(): Promise<User[]> {
        const response = await this.httpService.get<GetUsersResponse>('/v1/user');
        return response.data;
    }

    async getUser(user_id: number): Promise<User> {
        const response = await this.httpService.get<GetUserResponse>(`/v1/user/${user_id}`);
        return response.data;
    }

    async updateUser(user_id: number, data: UserUpdateDTO): Promise<User> {
        const response = await this.httpService.patch<UserUpdateResponse, UserUpdateDTO>(`/v1/user/${user_id}`, { data });
        return response.data;
    }

    async assignExtraPermissions(user_id: number, permissions: ExtraPermissionsList): Promise<ExtraPermissionResponse> {
        const response = await this.httpService.post<ExtraPermissionResponse, ExtraPermissionsList>(`/v1/user/${user_id}/extra_permissions`, { data: permissions });
        return response;
    }
    async assignExtraTags(user_id: number, tags: ExtraTagsList): Promise<ExtraTagsResponse> {
        const response = await this.httpService.post<ExtraTagsResponse, ExtraTagsList>(`/v1/user/${user_id}/extra_tags`, { data: tags });
        return response;
    }
    async deactivateUser(data: UserUpdateDTO): Promise<UserResponse> {
        const response = await this.httpService.patch<UserResponse, UserUpdateDTO>(`/v1/user/deactivate`, { data });
        return response;
    }
    async createUserOpt(): Promise<CreateUserOptResponse> {
        const response = await this.httpService.post<CreateUserOptResponse, void>(`/v1/user/opt`);
        return response;
    }
    async deleteUserOpt(): Promise<void> {
        await this.httpService.delete(`/v1/user/opt`);
        return;
    }

    async changeUserPassword(data: ChangeUserPasswordDTO): Promise<User> {
        const response = await this.httpService.post<User, ChangeUserPasswordDTO>(`/v1/user/password`, { data });
        return response;
    }
    async recoverUserPassword(data: RecoverUserPasswordDTO): Promise<RecoverUserPasswordResponse> {
        const response = await this.httpService.post<RecoverUserPasswordResponse, RecoverUserPasswordDTO>(`/v1/user/password/recovery`, { data });
        return response;
    }
}
